import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';

import { NavigatorComponent } from '@corecomponents/topbar/navigator';
import { TopbarDynamicItemsComponent } from './topbar-dynamic-items/topbar-dynamic-items.component';

@Component({
    selector: 'kt-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatToolbarModule,
        NavigatorComponent,
        TopbarDynamicItemsComponent,
    ]
})
export class TopbarComponent { }
